module.exports = __webpack_public_path__ + "static/media/iconFormation.36c25763.svg";